import { h, Component } from 'preact';

/* Loads the widget once only using a singleton pattern */
function getPressWidget(callback) {
	if (window.cqPressWidget) return callback(window.cqPressWidget);
	if (window.cqPressWidgetCallbacks) return window.cqPressWidgetCallbacks.push(callback);

	window.cqPressWidgetCallbacks = [callback];

	const script = document.createElement('script');
	script.addEventListener('load',() => {
		window.cqPressWidget = window.currentWidget;

		for (let callback of window.cqPressWidgetCallbacks) {
			callback(window.currentWidget);
		}

		delete window.cqPressWidgetCallbacks;
	});
	script.src = '//widgets.financialcontent.com/synacor/pressreleases.js';

	document.head.appendChild(script);
}

/*
 * The <PressWidget /> component defined below is a preact component
 * which will detect the path which it is placed under
 * and render the correct content depending on the location the user is navigated to.
 *
 * It needs no parameters passed to it.
 *
 * The component looks at the location.href parameter, and watches for
 * state changes in the global history object,
 * and thus will navigate alongside most types of client-side navigation.
 *
 * Please integrate it as follows, by making the following changes under these route paths:
 *
 * /finance/category/stockdetail/symbol/:symbol
 *   Add <PressWidget /> Below The Chart
 *
 * /finance/category/press
 *   Replace <iframe src="https://synacor.xmware.com/".... /> with <PressWidget />
 *
 * /finance/category/press/......
 *   These wildcard paths should render the same component as /finance/category/press
 *   Probably the only thing needed to make this happen is
 *   to remove the "exact" parameter from the react <Route>
 *   for the /finance/category/press page
 *
 *  WARNING: If you attempt to add the widget to any other path, it will render no content. This is intentional.
 */
export default class PressWidget extends Component {

	setPressWidgetRef = (el) => this.setState({ el });

	componentDidMount() {
		this.renderPressWidget({});
	}

	componentDidUpdate(props, state) {
		this.renderPressWidget(state);
	}

	renderPressWidget = ({ el: prevEl }) => {
		let { el } = this.state;
		if (el && el !== prevEl) {
			getPressWidget((pressWidget) => {
				if (!this.pressWidgetInstance) {
					this.pressWidgetInstance = new pressWidget({ el, Authorization: 'publicKey gqp28e0kv2a' });
				}
				this.pressWidgetInstance.render();
			});
		}
	}

	render() {
		return <div ref={this.setPressWidgetRef} />;
	}
}



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/press-widget/index.js